import {PageField} from '../forms/interfaces/page-field';
import {FormFieldPrefillOption} from '../enums/form-field-prefill-option.enum';

export function fieldsContainPatientInformation(fields: PageField[]): boolean {
  return !!fields.find((field) => field.prefillWith === FormFieldPrefillOption.PATIENT_PMS_ID);
}
